module.exports = __webpack_public_path__ + "img/third-onboarding-bg.f7708b92.svg";